import { validators } from '../../utils/validators';

const validate = values => {
    const { REQUIRE } = validators;
    const errors = {};
    if (REQUIRE(values)) {
        errors.form = 'Please enter Values first';
        errors.createdOn = 'Please enter Values first';
    }
    if (values.createdOn) {
        if (
            REQUIRE(values.createdOn.endDate) ||
            REQUIRE(values.createdOn.startDate)
        ) {
            errors.form = 'Please enter both dates';
            errors.createdOn = 'Please enter both dates';
        }
    }
    if (values.createdBy) {
        if (values.createdBy.length < 3) {
            errors.createdBy = 'Please enter at least 3 characters.';
        }
    }
    if (values.role) {
        if (values.role.length < 3) {
            errors.role = 'Please enter at least 3 characters.';
        }
    }
    if (values.time) {
        if (REQUIRE(values.time.startTime) || REQUIRE(values.time.endTime)) {
            errors.form = 'Please enter both start and end time';
            errors.time = 'Please enter both start and end time';
        }
        if (
            !values.createdOn ||
            REQUIRE(values.createdOn.endDate) ||
            REQUIRE(values.createdOn.startDate)
        ) {
            errors.form = 'Please enter both dates';
            errors.createdOn = 'Please enter both dates';
        }
    }
    return errors;
};

export default validate;
